import { logger } from '@/utils/logger';
import { httpClient } from '../../../../../search-library/src/utils/http';
import { CategorySuggests, ContextSuggestionsResponse, SuggestionCategory } from './categorySuggestionsInterface';

const getSearchHistoryKey = () => `fss.searchHistory.cat.${'de_DE'}`;
const SUGGESTION_TOTAL_LIMIT = 4;

export class CategorySuggestions {
  searchProfile!: string;
  savedSearches: Array<SuggestionCategory> = [];

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  init(searchProfile: string) {
    const localStorageContents = window.localStorage.getItem(getSearchHistoryKey());
    this.searchProfile = searchProfile;

    logger.log('CategorySuggestions init', searchProfile);

    if (localStorageContents) {
      this.savedSearches = JSON.parse(localStorageContents);
    }
  }

  getAllLocalSuggestions(): any {
    return this.savedSearches.length > 0
      ? [
          {
            category: {
              domain: '',
              displayName: '',
            },
            suggestions: this.savedSearches,
            isSuggestions: true,
            score: 1,
          },
        ]
      : [];
  }

  // eslint-disable-next-line class-methods-use-this
  fetchCategorySuggestions(query: string, domain = ''): Promise<ContextSuggestionsResponse> {
    const params = {
      limit: SUGGESTION_TOTAL_LIMIT,
      query,
      searchProfile: this.searchProfile,
      domains: domain,
    };
    const historic = this.savedSearches.filter((sug) =>
      sug.suggest?.toLowerCase().startsWith(query?.toLowerCase().trim()),
    );

    return httpClient
      .get<ContextSuggestionsResponse>('/context-suggestions', { params })
      .then(({ data: suggestionsResponse }) => {
        // case we dont have any historic, return call from backend
        if (historic.length === 0) {
          return suggestionsResponse;
        }

        suggestionsResponse.categorySuggests.forEach((item, index) => {
          suggestionsResponse.categorySuggests[index].suggestions = item.suggestions.filter(
            (sug: any) =>
              !historic.find((el) => el.suggest === sug.suggest && sug.category.domain === el.category.domain),
          );
        });

        const categoryWithHistoric: CategorySuggests = {
          category: {
            domain: '',
            displayName: '',
          },
          suggestions: historic,
          isSuggestions: true,
          score: 1,
        };

        return {
          ...suggestionsResponse,
          categorySuggests: [categoryWithHistoric].concat(suggestionsResponse.categorySuggests),
        };
      })
      .catch((e: any) => {
        logger.error(e);
        return Promise.reject(e);
      });
  }

  persist(): void {
    this.savedSearches = this.savedSearches.slice(0, SUGGESTION_TOTAL_LIMIT);

    window.localStorage.setItem(getSearchHistoryKey(), JSON.stringify(this.savedSearches));
  }

  addSuggestion(suggestion: SuggestionCategory): void {
    const isSaved = this.savedSearches.some((search) => search.suggest === suggestion.suggest.trim());

    if (isSaved) {
      return;
    }

    this.savedSearches.unshift(suggestion);
    this.persist();
  }

  removeSuggestion(suggestion: SuggestionCategory): void {
    const indexToRemove = this.savedSearches.findIndex(
      (search) => search.suggest === suggestion.suggest && search.category.domain === suggestion.category.domain,
    );

    if (indexToRemove > -1) {
      this.savedSearches.splice(indexToRemove, 1);
      this.persist();
    }

    logger.log('Suggestion removed', suggestion);
  }
}

export const categorySuggestions = new CategorySuggestions();
